const _html = (html = '') => <div dangerouslySetInnerHTML={{__html: html}}/>
export default _html;
